<template>
  <div class="main">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <router-link to="/console">创作者中心</router-link></li>
        <li class="breadcrumb-item"> <router-link to="/post">{{ this.$t('lang.title.post') }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ this.$t('lang.toolbar.Details') }}</li>
      </ol>
    </nav>
    <GeneralEdit v-bind:def="def"></GeneralEdit>
  </div>
</template>
<script>
import GeneralEdit from "../../components/GeneralEdit.vue";

import sx from "../../utils/core.js";
//  Import jquery
import $ from 'jquery'

//  Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  components: {
    GeneralEdit
  },
  data() {
    return {
      def: {
        tp: {
          areas: []
        }
      },
      mode: "update"
    };
  },
  watch: {
    '$i18n.locale': function (newVal) {
      console.log(newVal)
      const that = this
      that.init();
    }
  },
  methods: {
    init() {
      const that = this;

      //  edit definition
      that.def = {
        id: "myDetailsPost",
        updateurl: that.$store.state.baseurl + '/app/cmshelper/updatePost',
        inserturl: that.$store.state.baseurl + '/app/cmshelper/createPost',
        mode: that.mode,
        meta: {},
        tp: {
          areas: []
        }
      }

      //  create mode
      if (that.mode === "create") {
        that.createNew();
        return;
      }

      //  update mode
      const mymodal = sx.showWaiting()
      var params = {
        id: localStorage.getItem('postinfo.id'),
        token: localStorage.getItem("token") || "token"
      }
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostDetails'
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.items = result.data.rows
            if (that.items.length > 0) {
              that.def.meta = JSON.parse(that.items[0].meta || "{}")
              var dtl = $("#myDetailsPost")
              dtl.find(".card-body #dictwhere").val(JSON.stringify({ id: localStorage.getItem('postinfo.id') }));
              that.def.tp = that.tpinit(that.$store.state.tp.post, that.def.meta, that.items[0])
            }
            sx.hideWaiting(mymodal)
          } else if (result.status === 'tokenerr') {
            that.$router.replace({ name: 'Login' })
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        },
        function () {
          sx.login(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.items = result.data.rows
                if (that.items.length > 0) {
                  that.def.meta = JSON.parse(that.items[0].meta || "{}")
                  var dtl = $("#myDetailsPost")
                  dtl.find(".card-body #dictwhere").val(JSON.stringify({ id: localStorage.getItem('postinfo.id') }));
                  that.def.tp = that.tpinit(that.$store.state.tp.post, that.def.meta, that.items[0])
                }
                sx.hideWaiting(mymodal)
              } else {
                sx.toastError(that.$t('lang.error.failedRequest', { err: result.message }));
              }
            }
          )
        }
      )
      sx.hideWaiting(mymodal)
    },
    dataToItem(item, dat) {
      const that = this
      if (item.locale) {
        item.title = that.$t(item.locale)
        item.placeholder = that.$t(item.locale)
      }
      if (item.optcate) {
        if (item.type === 'tagsinput') {
          if (item.optcate === "taglist") {
            item.tag = dat[item.id];
            item.opts = sx.gettags(that.$store.state.taglist);
            item.optlist = that.$store.state.taglist
          } else {
            item.tag = dat[item.id];
            item.opts = sx.gettags(sx.opts(item.optcate, that.$i18n.locale))
            item.optlist = sx.opts(item.optcate, that.$i18n.locale)
          }
        } else {
          if (item.optcate === "categorylist") {
            item.opts = that.$store.state.categorylist
          } else if (item.optcate === "contactlist") {
            item.opts = that.$store.state.contactlist
          } else if (item.optcate === "authgrplist") {
            item.opts = that.$store.state.authgrplist
          } else if (item.optcate === "dictionary") {
            item.opts = that.$store.state.dict[item.catename]
          } else {
            item.opts = sx.opts(item.optcate, that.$i18n.locale)
          }
        }
      }
      if (dat[item.id]) {
        item.val = dat[item.id];
      } else {
        item.val = "";
      }
    },
    tpinit(tp, meta, base) {
      const that = this;
      // base items
      tp.items.forEach(function (item) {
        if (item.groups) {
          item.groups.forEach(function (itemcell) {
            that.dataToItem(itemcell, base)
          });
        } else {
          that.dataToItem(item, base)
        }
      });
      // areas
      tp.areas.forEach(function (area) {
        if (area.locale) {
          area.name = that.$t(area.locale)
        }
        area.groups.forEach(function (group) {
          if (group.locale) {
            group.name = that.$t(group.locale)
          }
          group.items.forEach(function (item) {
            if (item.locale) {
              item.title = that.$t(item.locale)
              item.placeholder = that.$t(item.locale)
            }
            if (item.optcate) {
              if (item.type === 'tagsinput') {
                if (item.optcate === "taglist") {
                  item.tag = meta[item.id];
                  item.opts = sx.gettags(that.$store.state.taglist);
                  item.optlist = that.$store.state.taglist
                } else {
                  item.tag = meta[item.id];
                  item.opts = sx.gettags(sx.opts(item.optcate, that.$i18n.locale))
                  item.optlist = sx.opts(item.optcate, that.$i18n.locale)
                }
              } else {
                if (item.optcate === "categorylist") {
                  item.opts = that.$store.state.categorylist
                } else if (item.optcate === "contactlist") {
                  item.opts = that.$store.state.contactlist
                } else if (item.optcate === "authgrplist") {
                  item.opts = that.$store.state.authgrplist
                } else if (item.optcate === "dictionary") {
                  item.opts = that.$store.state.dict[item.cataname]
                } else {
                  item.opts = sx.opts(item.optcate, that.$i18n.locale)
                }
              }
            }
            if (meta[item.id]) {
              if (item.type === "paragraphs") {
                item.paragraphs = meta[item.id].paragraphs;
                item.seq = meta[item.id].seq;
                $.each(item.paragraphs, function (index, paragraph) {
                  $.each(paragraph.parts, function (index2, part) {
                    if (!sx.isNothingOrEmpty(part.code)) {
                      part.showCode = true;
                    }
                  });
                });
              } else {
                item.val = meta[item.id];
              }
            } else {
              if (item.type === "paragraphs") {
                item.paragraphs = [];
                item.seq = 1;
              }
            }
          });
        });
      });
      return tp;
    },
    createNew() {
      const that = this;
      that.def.meta = JSON.parse("{}")
      that.def.tp = that.tpinit(that.$store.state.tp.post, that.def.meta, {})
    }
  },
  mounted() {
    const that = this;
    //  mode
    if (that.$route.query.mode) {
      that.mode = that.$route.query.mode
    }

    that.init();
  },
  destroyed() {
    console.log("destroyed")
    const that = this;
    if (that.timer) {
      clearInterval(that.timer);
    }
  }
}
</script>
